import type { ComputedRef, Ref } from 'vue'
import { computed } from 'vue'
import type { MetalCode, ReadyToGoRingFragment } from '@/graphql/api'
import { useRoutes } from '@/router/routes'
import type { Breadcrumb } from '@/components/ui/Breadcrumbs.vue'
import { useI18n } from 'vue-i18n'

export function useReadyToGoRingBreadcrumbs(
    ring: Readonly<Ref<ReadyToGoRingFragment | undefined | null>>,
    metal: Readonly<Ref<MetalCode>>
): ComputedRef<Breadcrumb[]> {
    const routes = useRoutes()
    const { t } = useI18n()

    return computed<Breadcrumb[]>(() =>
        ring.value?.isReadyToShip
            ? []
            : [
                  {
                      title: t('globals.home'),
                      to: routes.home(),
                  },
                  {
                      title: t('catalogue.ready_to_go.title'),
                      to: routes.readyToGoRings(),
                  },
                  {
                      title: ring.value?.primaryMetal.translation.name || '',
                      to: routes.readyToGoRings(metal.value),
                  },
                  {
                      title: ring.value?.productName || '',
                  },
              ]
    )
}
